import { render, staticRenderFns } from "./EditLinkedDigiBoards.vue?vue&type=template&id=cdff396e&scoped=true"
import script from "./EditLinkedDigiBoards.vue?vue&type=script&lang=js"
export * from "./EditLinkedDigiBoards.vue?vue&type=script&lang=js"
import style0 from "./EditLinkedDigiBoards.vue?vue&type=style&index=0&id=cdff396e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdff396e",
  null
  
)

export default component.exports